import { Box } from '@mui/material';
import ExploreOutlined from '@mui/icons-material/ExploreOutlined';
import { MUSEFLOW_ORANGE } from 'Components/Colors';
import { PlayInput } from 'Types';
import KeyboardConnectMidi from 'assets/images/KeyboardConnectMidi.png?url&no-inline';
import MidiKeyboard from 'assets/images/MidiKeyboard.png?url&no-inline';
import MidiKeyboardSound from 'assets/images/MidiKeyboardSound.png?url&no-inline';

// The device screen's pictures, imported for their address in the build. This picker sits in the
// lesson, piece, tutorial and settings screens, and in that form their specs load it as they are.
const PICTURES: Record<Exclude<PlayInput, 'none'>, string> = {
  midi: KeyboardConnectMidi,
  unconnected_piano: MidiKeyboardSound,
};

/**
 * The device screen's picture for an answer, drawn to fit the box it is put
 * in: a keyboard with its cable, a keyboard with speakers, and for "Nothing
 * yet" a faded keyboard under a compass. Decorative: the answer's text names it.
 */
export default function PlayInputPicture({ playInput }: { playInput: PlayInput }) {
  const imageSx = { display: 'block', maxWidth: '100%', maxHeight: '100%' } as const;
  if (playInput !== 'none') {
    return <Box component="img" src={PICTURES[playInput]} alt="" aria-hidden sx={imageSx} />;
  }
  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="img"
        src={MidiKeyboard}
        alt=""
        sx={{ ...imageSx, opacity: 0.3, filter: 'grayscale(1)' }}
      />
      <ExploreOutlined
        sx={{ position: 'absolute', height: '90%', width: 'auto', color: MUSEFLOW_ORANGE }}
      />
    </Box>
  );
}
